import React from "react";
import { Col, Row } from "antd";
import { GenericCard } from "../../common/components/GenericCard";

interface NegotiationLeversTableHeaderProps {
    title: string;
    score: number;
    grade: string;
    potential: number;
}

export const NegotiationLeversTableHeader: React.FC<NegotiationLeversTableHeaderProps> = ({
    title,
    score,
    grade,
    potential,
}) => (
    <Row align="middle">
        <Col flex={1}>
            {title}:{" "}
            <span style={{ color: "#FF7A1A", fontWeight: 600 }}>
                {score}% ({grade})
            </span>
        </Col>
        <Col>
            <GenericCard size="small" type="success" style={{ color: "#4FBD19", fontWeight: 500 }}>
                Your deal has potential to improve by {potential}%
            </GenericCard>
        </Col>
    </Row>
);
